<template lang="pug">
  v-content
    v-container(fluid ma-0 pa-0 fill-height)
      v-layout#fullscreen-block(row)
        v-flex
          .rtl
            v-layout(row wrap px-2)
              v-flex(xs12 px-2)
                v-text-field(:label="'פריט'" v-model="item.Itemdescription" append-icon='format_paint')
              v-flex(xs12 px-2)
                v-text-field(:label="'כמות'" v-model="item.Quantity" append-icon='swap_calls')

              v-flex(xs12 pt-2)
                v-layout(row wrap)
                  v-flex(xs12 pl-1)
                    v-btn(block @click='insert()' color="red lighten-1" dark)  הוסף


</template>

<script>
const moment = require('moment-timezone');

export default {
  data: () => ({
    item: {}
  }),

  created() {
    this.$socket.on('*', (packet) => {
      let channel = packet.data[0];
      let data = packet.data[1];
      let $uniqid = data.$uniqid;
      if ($uniqid) {
        return this.$socket.res(data);
      }
      this.sockets(channel, data);
    });

    this.$emit('update:loading', false);
  },

  beforeRouteLeave(to, from, next) {
    this.$socket.off('*');
    this.$emit('update:loading', true);
    next();
  },

  methods: {

    insert: function () {
      this.loading = true;
      this.$emit('update:loading', true);

      // console.log(this.$user)

      this.$socket.req('sendi.insert.add_row', {...this.item, user: this.$user}).then(() => {
        setTimeout(() => {
          this.item = {};
          this.loading = false;
          this.$emit('update:loading', false);
          this.$emit('update:snackbar', {
            text : '✌ הַחֹסַר עודכן בהצלחה',
            show : true
          });
        }, 750);
      });
    },

    sockets: function (channel, data) {
      let channels = {
        'screen.data.reload': (data) => {
          console.log('screen.data.reload BAD!!')
          // this.getData();
        }
      };
      if (!channels[channel]) {
        return console.log('Socket channel not found:', channel);
      }

      return channels[channel](data);
    }
  }
}
</script>

<style lang="sass">

</style>
